import api from "./index";

export const laborAPI = {
  // Time entries
  addTimeEntry: (data) => api.post("/labor/time-entry", data),
  clockIn: (data) => api.post("/labor/clock-in", data),
  clockOut: (data) => api.post("/labor/clock-out", data),
  getTimesheets: (params) => api.get("/labor/timesheets", { params }),
  approveTimesheet: (id) => api.put(`/labor/time-entry/${id}/approve`),
  getSummary: (projectId, params) =>
    api.get(`/labor/summary/${projectId}`, { params }),

  // Assignments
  assignWorker: (data) => api.post("/labor/assign", data),
  updateAssignment: (id, data) => api.put(`/labor/assign/${id}`, data),
  getAssignments: (params) => api.get("/labor/assignments", { params }),
};
